<template>
  <div class="home-wrapper" @click="interactCheck" @touchstart="interactCheck" @touchmove="interactCheck">
    <!-- 대기불가 화면 -->
    <div v-if="isUnable" class="unable-wrap">
      <div class="store-info">
        <div class="store-name">
          <img @click="openInput" src="@/assets/logo-text.svg" alt="logo" />
          <div class="name" :class="{'long-name': restaurant.name.length > 29}">
            <text-ellipsis line="1" >{{ restaurant.name }}</text-ellipsis>
          </div>
        </div>
        <LanguageBar :isFlagIcon="true" />
      </div>
      <div class="text-wrap">
        <div class="text" :class="{'custom-text': isCustomFinishText}" v-html="getScopeMessage"></div>
        <hr class="divider"/>
        <div class="waiting-count-wrap">
          <div v-if="restaurant.useWaitingConfirmCode" class="confirm-queue-number" v-html="(restaurant.useWaitingConfirmCode) ? $tc('home_02_confirmQueueNumber', otpNumber) : $tc('no_code_number')"></div>
          <div class="waiting-count" v-html="$tc('waiting_count', this.restaurant.useWaitingQueue ? this.totalQueueCnt : waitingCount)"></div>
        </div>
      </div>
    </div>
    <!-- 대기 화면 -->
    <div v-if="!isUnable" class="waiting-wrap" :class="{'use-custom-color': useCustomColor}">
      <!-- 대기열 사용 매장 -->
      <div v-if="restaurant.useWaitingQueue" class="waiting-queue">
        <div class="content">
          <LanguageBar :isFlagIcon="true" />
          <div class="info-box">
            <div class="store-info">
              <div class="store-name">
                <img src="@/assets/logo-text.svg" alt="logo" />
                <div class="name">
                  <text-ellipsis line="2" >{{ restaurant.name }}</text-ellipsis>
                </div>
              </div>
              <div class="confirm-queue-number" :class="{'no-otp-code': !restaurant.useWaitingConfirmCode}" v-html="(restaurant.useWaitingConfirmCode) ? $tc('home_02_confirmQueueNumber', otpNumber) : $tc('no_code_number')"></div>
            </div>
            <div class="notice-wrap">
              <div class="title">{{ $tc('home_01_notice') }}</div>
              <div class="content" v-html="displayNotice"></div>
            </div>
          </div>
          <div class="queue-box">
            <queue-card :queueList="getQueueList" :isWaitingDisabled="waitingDisabled" @useQueueWaiting="handlingQueueWaiting"/>
          </div>
        </div>
        <Footer :version="version" :errorMessage="(isSocketDisconnected ? $tc('home_03_weakWifiSignal') : '')" />
      </div>
      <!-- 대기열 미사용 매장 -->
      <div v-else class="no-waiting-queue">
        <div class="content">
          <div class="info-wrap">
            <div class="store-info">
              <div class="store-name">
                <img src="@/assets/logo-text.svg" alt="logo" />
                <div class="name" :class="{'long-name': restaurant.name.length > 29}">
                  <text-ellipsis line="1" >{{ restaurant.name }}</text-ellipsis>
                </div>
              </div>
              <LanguageBar :isFlagIcon="true" />
            </div>
            <div class="waiting-count" v-html="$tc('waiting_count', waitingCount)"></div>
            <div v-if="waitingDisabled" class="waiting-start-btn disabled" v-html="$tc('emptyMenuList')"></div>
            <div v-else class="waiting-start-btn" @click="handlingStart">{{ $t("start_waiting") }}</div>
          </div>
          <div class="notice-wrap">
            <div v-if="restaurant.useWaitingConfirmCode" class="confirm-queue-number" v-html="(restaurant.useWaitingConfirmCode) ? $tc('home_02_confirmQueueNumber', otpNumber) : $tc('no_code_number')"></div>
            <div class="notice-content" :class="{'no-otp-code': !restaurant.useWaitingConfirmCode}">
              <div class="title">{{ $tc('home_01_notice') }}</div>
              <div class="content" v-html="displayNotice"></div>
            </div>
          </div>
        </div>
        <Footer :version="version" :errorMessage="(isSocketDisconnected ? $tc('home_03_weakWifiSignal') : '')" :isLeftPadding="true" />
      </div>
    </div>
    <div class="popup-wrap" v-show="isShowNotiPopup">
      <div class="noti-pop">
        <div class="contents-wrap">
          <div class="title">
            <img src="@/assets/Notice.svg" />
            <span>{{ noticePopupTitle }}</span>
          </div>
          <div class="text" v-html="restaurant.notice.confirm"></div>
        </div>
        <div class="button-wrap">
          <div class="button cancel" @click="closeNotiPopup">{{ $tc('notice_popup_cancel') }}</div>
          <div class="button confirm" @click.once="start">{{ $tc('notice_popup_confirm') }}</div>
        </div>
      </div>
    </div>
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import { noticePopup } from './mixins/noticePopup'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import queueCard from '@/components/queueCard.vue'
import { textEllipsis } from '@/components/text'
import Footer from '@/components/Footer.vue'
import { renewalLoginStatus } from '@/shared/validation/login/index'
import LanguageBar from '@/components/LanguageBar.vue'
import packageFile from '../../package.json'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Home',
  mixins: [timeout, noticePopup],
  components: {
    LanguageBar,
    Footer,
    textEllipsis,
    queueCard,
    timeoutPopup
  },
  computed: {
    ...mapGetters(['isOffline', 'isSocketDisconnected', 'isUseParallelQueue', 'getQueueList', 'getRestaurantInfo']),
    ...mapState(['restaurant', 'locale', 'otpNumber', 'waitingCount', 'waitingCountChange', 'restaurantInfoChange', 'menuInfoChange', 'restaurantMenuInfo']),
    // 리뉴얼 컬러 예외매장 여부 - 우래옥
    useCustomColor () {
      return (process.env.VUE_APP_CUSTOM_COLOR && process.env.VUE_APP_CUSTOM_COLOR.includes(this.restaurant.idx))
    },
    totalQueueCnt () {
      let cnt = this.waitingCount
      if (this.restaurant.useWaitingQueue) {
        cnt = 0
        this.getQueueList.map(queue => {
          cnt = Number(cnt) + Number(queue.count)
        })
      }
      return cnt
    },
    isCustomFinishText () {
      return process.env.VUE_APP_CUSTOM_FINISH_TEXT && process.env.VUE_APP_CUSTOM_FINISH_TEXT.includes(this.restaurant.idx)
    },
    getScopeMessage () {
      const suffix = this.isCustomFinishText ? '_custom' : ''
      let result = ''
      if (this.getRestaurantInfo.message.includes('브레이크')) result = this.$tc(`home_09_finish_text_breaktime${suffix}`)
      if (this.getRestaurantInfo.message.includes('마감')) result = this.$tc(`home_10_finish_queue_end${suffix}`)
      if (this.getRestaurantInfo.message.includes('재료')) result = this.$tc(`home_11_finish_material_exhaustion${suffix}`)
      if (this.getRestaurantInfo.message.includes('바로')) result = this.$tc('home_12_finish_pass')
      if (this.getRestaurantInfo.message.includes('임시')) result = this.$tc(`home_13_finish_temp_end${suffix}`)
      return result
    },
    isExceptionStore () {
      return (process.env.VUE_APP_EXCEPTION_STORE && process.env.VUE_APP_EXCEPTION_STORE.includes(this.stoerIdx))
    },
    stoerIdx () {
      return this.$store.getters.getStoreIdx
    },
    displayNotice () {
      let defaultMsg = ''
      if (this.restaurant.phoneRequired) {
        defaultMsg = (this.restaurant.menuRequired)
          ? '<ul><li>대기 신청 시 메뉴를 선택할 수 있습니다.</li><li>대기 번호 및 선택한 메뉴 정보는 대기 접수 후 받는 알림톡에서 확인하실 수 있습니다. 핸드폰 번호를 정확하게 입력해 주세요.</li><li>매장에서 호출 후 바로 입장하지 않으면 취소 처리될 수 있으니 매장 근처에서 대기해 주세요.</li><li>대기 접수 후 노쇼 시 페널티가 부과되어 테이블링 서비스 이용이 불가할 수 있습니다.</li></ul>'
          : '<ul><li>대기 번호는 대기 접수 후 받는 알림톡에서 확인하실 수 있습니다. 핸드폰 번호를 정확하게 입력해 주세요.</li><li>매장에서 호출 후 바로 입장하지 않으면 취소 처리될 수 있으니 매장 근처에서 대기해 주세요.</li><li>대기 접수 후 노쇼 시 페널티가 부과되어 테이블링 서비스 이용이 불가할 수 있습니다.</li></ul>'
      } else {
        defaultMsg = (this.restaurant.isNumTicket)
          ? '<ul><li>대기 접수 완료 후 번호표가 출력됩니다. 번호표를 잘 챙겨주세요!</li><li>매장에서 호출 시 바로 입장하지 않으면 취소 처리될 수 있으니 매장 근처에서 대기해 주세요.</li><li>대기 접수 후 노쇼 시 페널티가 부과되어 테이블링 서비스 이용이 불가할 수 있습니다.</li></ul>'
          : '<ul><li>대기 번호를 잊어버리지 않도록 대기 접수 완료 후 핸드폰 카메라로 대기 번호를 찍어 기록해 주세요.</li><li>매장에서 호출 시 바로 입장하지 않으면 취소 처리될 수 있으니 매장 근처에서 대기해 주세요.</li><li>대기 접수 후 노쇼 시 페널티가 부과되어 테이블링 서비스 이용이 불가할 수 있습니다.</li></ul>'
      }
      return this.restaurant.notice.basic ? this.restaurant.notice.basic : defaultMsg
    },
    version () {
      return packageFile.version
    },
    isUnable () {
      const isAllQueueClosed = this.getQueueList.findIndex((queue) => queue.isClosed === false)
      return (this.restaurant.useWaitingQueue) ? (this.restaurant.useWaitingQueue && isAllQueueClosed === -1) : (this.restaurant.status === 'PRIVATE' || this.restaurant.status === 'TRANSIENT')
    },
    isStop () {
      return this.restaurant.status === 'PRIVATE'
    },
    isEnd () {
      return this.restaurant.status === 'TRANSIENT'
    }
  },
  watch: {
    async menuInfoChange (val) {
      if (val) {
        if (this.restaurant.menuRequired) {
          await this.$store.dispatch('setRestaurantMenuList')
          let menuCnt = 0
          this.restaurantMenuInfo.list.forEach((cate) => {
            menuCnt = Number(menuCnt) + Number(cate.menus.length)
          })
          this.waitingDisabled = (menuCnt === 0)
        }
        this.$store.commit('menuInfoChange', false)
      }
    }
  },
  data () {
    return {
      waitingDisabled: false,
      isShowNotiPopup: false // 공지 팝업 노출 여부
    }
  },
  methods: {
    // timeout.js에 있는 interactCheck 제장의
    interactCheck () {
      if (this.isShowNotiPopup) {
        this.setTimer()
      }
    },
    // timeout.js에 있는 moveToHome 제장의
    moveToHome () {
      // console.debug('moveToHome Home')
      this.isShowTimeOutPop = false
      this.isShowNotiPopup = false
    },
    // timeout.js에 있는 closeTimeoutPopup 제장의
    closeTimeoutPopup () {
      // console.debug('closeTimeoutPopup Home')
      this.isShowTimeOutPop = false
      if (this.isShowNotiPopup) {
        this.setTimer()
      }
    },
    // 공지 팝업 close
    closeNotiPopup () {
      // console.debug('closeNotiPopup---', this.timeoutObj)
      clearTimeout(this.timeoutObj)
      this.isShowNotiPopup = false
    },
    handlingStart () {
      if (this.isExceptionStore && this.restaurant.notice.confirm) {
        this.openNoticePop()
      } else {
        this.start()
      }
    },
    handlingQueueWaiting (queue) {
      const queueData = {
        queueName: queue.name,
        queueIndex: queue.index
      }

      // 다국어 정보가 있으면 함께 저장
      if (queue.multiLanguage && queue.multiLanguage.name) {
        queueData.queueNameMultiLanguage = queue.multiLanguage.name
      }

      this.$store.commit('setWaitingParams', queueData)
      if (this.isExceptionStore && this.restaurant.notice.confirm) {
        this.openNoticePop()
      } else {
        this.start()
      }
    },
    // 공지 팝업 오픈
    openNoticePop () {
      this.isShowNotiPopup = true
      this.setTimer()
    },
    start () {
      if (this.waitingDisabled) return
      if (this.restaurant.phoneRequired && !(this.locale !== 'ko' && this.restaurant.isNumTicket)) {
        this.$router.push('/notice')
        return
      }
      this.$router.push('/select-person')
    },
    openInput () {
      const result = prompt('코드를 입력하세요')
      if (result === '025529045') {
        this.$router.replace('/login')
      }
      if (result === '18999195') {
        this.reload()
      }
    }
  },
  mounted () {
    // accessToken, storeIdx store/localStorage 갱신
    renewalLoginStatus()
    // setWaitingParam init
    const initParams = {
      name: '',
      phoneNumber: '',
      numOfPeople: 1,
      childCount: 0,
      memo: '',
      source: 'KIOSK',
      isAgreement: false,
      isMarketing: false,
      isThirdParty: false,
      isPartnerInfoAgreement: false,
      isPartnerAdAgreement: false,
      isNoPhone: false,
      isNumTicket: false,
      menus: new Map(),
      queueIndex: -1,
      queueName: '',
      email: '',
      tempKey: ''
    }
    this.$store.commit('setWaitingParams', initParams)
    this.$store.commit('mutationByKeyValue', [{ key: 'receivedLineTempKey', value: '' }])
    this.$store.commit('clearSelectedClientRequest')
  },
  async created () {
    await this.$store.dispatch('setRestaurant', this.stoerIdx)
    await this.$store.dispatch('setWaitingCount', this.stoerIdx)
    if (this.waitingCountChange) {
      await this.$store.dispatch('setWaitingCount', this.stoerIdx)
      this.$store.commit('waitingCountChange', false)
    }
    if (this.restaurantInfoChange) {
      await this.$store.dispatch('setRestaurant', this.stoerIdx)
      this.$store.commit('restaurantInfoChange', false)
    }
    if (this.menuInfoChange || this.restaurant.menuRequired) {
      if (this.restaurant.menuRequired) {
        await this.$store.dispatch('setRestaurantMenuList')
        let menuCnt = 0
        this.restaurantMenuInfo.list.forEach((cate) => {
          menuCnt = Number(menuCnt) + Number(cate.menus.length)
        })
        this.waitingDisabled = (menuCnt === 0)
      }
      this.$store.commit('menuInfoChange', false)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/base.scss";
.home-wrapper {
  /* width: 1280px;
  height: 800px; */
  width: 100%;
  height: 100vh;
  background: #1E1F21;
}
// 대기열 사용 매장
.waiting-queue {
  display: flex;
  flex-direction: column;
  padding: 2.5vh 1.5625vw 7.25vh;
  .content {
    display: flex;
    flex-direction: column;
    @include flex-gap(2.5vh, column);
    .flag-icon-wrap {
      margin: 0 auto;
    }
    .info-box {
      display: flex;
      @include flex-gap(1.875vw, row);
      .store-info {
        width: calc(50% - 0.9375vw);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @include flex-gap(3.5vh, column);
        padding: 0 0.9375vw;
        .store-name {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          @include flex-gap(2.25vh, column);
          img {
            width: 6.25vw;
            height: 3vh;
          }
          .name {
            max-width: 43.28125vw;
            font-size: 36px; // IE11 fallback
            font-size: unquote("min(2.8125vw, 36px)");
            font-weight: 700;
            line-height: 5.375vh;
            color: $white;
            p {
              height: auto;
              max-height: 10.75vh;
              text-align: center;
            }
          }
        }
        .confirm-queue-number {
          display: flex;
          padding: 20px 24px;
          justify-content: center;
          align-items: center;
          @include flex-gap(1.5vh, row);
          border-radius: 2.5vh;
          background: #2E3137;
          font-size: 32px; // IE11 fallback
          font-size: unquote("min(2.5vw, 32px)");
          font-weight: 700;
          line-height: 4.5vh;
          color: $white;
          .confirm-number {
            color: #FCE800;
          }
          &.no-otp-code {
            padding: 2vh 2.1875vw;
            color: #969FAC;
          }
        }
      }
      .notice-wrap {
        width: calc(50% - 0.9375vw);
        height: 30.25vh;
        display: flex;
        padding: 3.75vh 2.1875vw;
        flex-direction: column;
        align-items: flex-start;
        @include flex-gap(2vh, column);
        flex: 1 0 0;
        border-radius: 2.5vh;
        background: #2E3137;
        .title {
          font-size: 28px; // IE11 fallback
          font-size: unquote("min(2.1875vw, 28px)");
          font-weight: 700;
          line-height: 4vh;
          color: $white;
        }
        .content {
          padding: 0 16px 0 0;
          width: 100%;
          font-size: 20px; // IE11 fallback
          font-size: unquote("min(1.5625vw, 20px)");
          font-weight: 400;
          line-height: 4vh;
          color: $white;
          overflow-y: scroll;
          word-break: break-all;
          max-height: 16.75vh;
          scrollbar-width: thin;
          &::-webkit-scrollbar {
            display: block;
            width: 10px;
            background: #D7DBDF;
          }
          &::-webkit-scrollbar-thumb {
            background: #D7DBDF;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .footer-container {
    margin: 2vh 0 0;
    // position: absolute;
    // bottom: 2.5vh;
    // right: 1.5625vw;
  }
}

// 대기열 미사용 매장
.no-waiting-queue {
  display: flex;
  flex-direction: column;
  @include flex-gap(2.5vh, column);
  padding: 6.25vh 3.90625vw 3.75vh;
  .content {
    display: flex;
    @include flex-gap(4.6875vw, row);
    .info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @include flex-gap(3.75vh, column);
      width: 100%;
      .store-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include flex-gap(3.75vh, column);
        .store-name {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          @include flex-gap(1.5vh, column);
          .name {
            max-width: 56.25vw;
            color: $white;
            text-align: center;
            font-size: 36px; // IE11 fallback
            font-size: unquote("min(2.8125vw, 36px)");
            font-weight: 700;
            line-height: 5.375vh;
            &.long-name {
              font-size: 30px; // IE11 fallback
              font-size: unquote("min(2.34375vw, 30px)");
            }
            p {
              text-align: center;
            }
          }
        }
      }
      .waiting-count {
        display: flex;
        flex-direction: column;
        @include flex-gap(3.75vh, column);
        color: $white;
        text-align: center;
        font-size: 100px; // IE11 fallback
        font-size: unquote("min(8.59375vw, 100px)");
        font-weight: 800;
        line-height: 1.1;
        div {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          color: #D81B1B;
          font-size: 150px; // IE11 fallback
          font-size: unquote("min(11.719vw, 150px)");
          font-weight: 800;
          line-height: 0.733;
          span {
            margin-left: 0.46875vw;
            font-size: 100px; // IE11 fallback
            font-size: unquote("min(7.8125vw, 100px)");
            font-weight: 800;
            line-height: 0.9;
          }
        }
      }
      .waiting-start-btn {
        display: flex;
        padding: 3.5vh 0;
        align-items: center;
        justify-content: center;
        color: $white;
        font-size: 32px;
        font-weight: 700;
        line-height: 4.75vh;
        border-radius: 2.5vh;
        background: #D81B1B;
        cursor: pointer;
        &.disabled {
          padding: 2.5vh 1.5625vw;
          border-radius: 3vh;
          background: #2E3137;
          color: #FFF;
          font-size: 24px; // IE11 fallback
          font-size: unquote("min(1.875vw, 24px)");
          font-weight: 600;
          line-height: 4.75vh;
          text-align: center;
        }
      }
    }
    .notice-wrap {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      @include flex-gap(2.5vh, column);
      width: 31.25vw;
      .confirm-queue-number {
        display: flex;
        padding: 20px 0;
        justify-content: center;
        align-items: center;
        @include flex-gap(1.5vh, row);
        border-radius: 2.5vh;
        background: #2E3137;
        font-size: 34px; // IE11 fallback
        font-size: unquote("min(2.65625vw, 34px)");
        font-weight: 700;
        line-height: 4.5vh;
        color: $white;
        border: 0.5vh solid #525965;
        .confirm-number {
          color: #FCE800;
        }
      }
      .notice-content {
        display: flex;
        flex-direction: column;
        @include flex-gap(2vh, column);
        height: 71vh;
        padding: 28px;
        border-radius: 2.5vh;
        background: #2E3137;
        &.no-otp-code {
          height: 84vh;
        }
        .title {
          color: $white;
          font-size: 28px; // IE11 fallback
          font-size: unquote("min(2.1875vw, 28px)");
          font-weight: 700;
          line-height: 4vh;
        }
        .content {
          color: $white;
          font-size: 24px; // IE11 fallback
          font-size: unquote("min(1.875vw, 24px)");
          font-weight: 400;
          line-height: 4.5vh;
          overflow-y: auto;
          scrollbar-width: thin;
          &::-webkit-scrollbar {
            display: block;
            width: 10px;
            background: #D7DBDF;
          }
          &::-webkit-scrollbar-thumb {
            background: #D7DBDF;
            border-radius: 10px;
          }
          ul {
            padding: 0 16px 0 0;
          }
        }
      }
    }
  }
}
// 대기 불가 화면
.unable-wrap {
  display: flex;
  flex-direction: column;
  @include flex-gap(2.3125vh, column);
  width: 100%;
  height: 100vh;
  padding: 6.25vh 3.90625vw;
  .store-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    @include flex-gap(3.75vh, column);
    .store-name {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      @include flex-gap(1.5vh, column);
      .name {
        max-width: 78.125vw;
        color: $white;
        font-size: 36px; // IE11 fallback
        font-size: unquote("min(2.8125vw, 36px)");
        font-weight: 700;
        line-height: 5.375vh;
        &.long-name {
          font-size: 30px; // IE11 fallback
          font-size: unquote("min(2.34375vw, 30px)");
        }
        p {
          text-align: center;
        }
      }
    }
  }
  .text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include flex-gap(5vh, column);
    height: 100vh;
    .text {
      color: $white;
      font-size: 85px; // IE11 fallback
      font-size: unquote("min(6.640625vw, 85px)");
      font-weight: 700;
      line-height: 15vh;
      text-align: center;
      &.custom-text {
        line-height: 12vh;
        font-size: 62px; // IE11 fallback
        font-size: unquote("min(6.640625vw, 62px)");
      }
    }
    .divider {
      width: 78.125vw;
      margin: 5vh 0 0;
      // border-top: 1px solid #B7BEC8;
      background: #B7BEC8;
      height: 1px;
      border: none;
    }
    .waiting-count-wrap {
      display: flex;
      justify-content: center;
      @include flex-gap(2.5vh, row);
    }
    .confirm-queue-number, .waiting-count {
      display: flex;
      padding: 20px 24px;
      justify-content: center;
      align-items: center;
      @include flex-gap(1.5vh, row);
      border-radius: 20px;
      background: #2E3137;
      font-size: 34px; // IE11 fallback
      font-size: unquote("min(2.65625vw, 34px)");
      font-weight: 700;
      line-height: 4.5vh;
      color: $white;
      // border: 0.5vh solid #525965;
      .confirm-number, .waiting-count-number {
        color: #FCE800;
      }
    }
  }
}

.popup-wrap {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  .noti-pop {
    display: flex;
    width: 66.40625vw;
    height: 82.5vh;
    padding: 6.25vh 3.90625vw;
    flex-direction: column;
    align-items: flex-start;
    @include flex-gap(5vh, column);
    border-radius: 4vh;
    border: 0.125vh solid #E0E0E0;
    background: $white;
    .contents-wrap {
      display: flex;
      flex-direction: column;
      @include flex-gap(3.5vh, column);
      width: 100%;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        @include flex-gap(16px, row);
        color: $black;
        font-size: 40px; // IE11 fallback
        font-size: unquote("min(3.125vw, 40px)");
        font-weight: 700;
        line-height: 6.75vh;
        text-align: center;
      }
      .text {
        height: 43vh;
        padding: 3vh 1.875vw;
        border-radius: 3vh;
        border: 0.125vh solid #B7BEC8;
        background: #F8F9FA;
        overflow-y: auto;
        color: #131517;
        font-size: 24px; // IE11 fallback
        font-size: unquote("min(1.875vw, 24px)");
        font-weight: 600;
        line-height: 4.75vh;
      }
    }
    .button-wrap {
      display: flex;
      @include flex-gap(2.5vh, row);
      width: 100%;
      .button {
        display: flex;
        width: 100%;
        height: 11.75vh;
        padding: 3.25vh 0.78125vw;
        justify-content: center;
        align-items: center;
        border-radius: 2.5vh;
        background: #E6E8EB;
        color: #2E3137;
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        font-weight: 700;
        line-height: 4.75vh;
        cursor: pointer;
      }
      .confirm {
        background: #D81B1B;
        color: $white;
      }
    }
  }
}

// 리뉴얼 컬러 예외매장 스타일
.use-custom-color {
  .no-waiting-queue .content .info-wrap {
    .waiting-start-btn {
      background: #0091FF;
    }
    .waiting-count div{
      color: #FCE800;
    }
  }
}
</style>
